import { isNil } from 'ramda';
import dayjs from 'dayjs';
import { toNumStrOrNull } from 'src/helpers/FPUtils';
import { WTS_MOMENT_DATE_MASK } from 'src/constants/dayjs';
export function ascSort(prev, next) {
    if (isNil(prev)) {
        return 1;
    }
    if (isNil(next)) {
        return -1;
    }
    if (typeof prev === 'number' && typeof next === 'string') {
        return -1;
    }
    if (typeof prev === 'string' && typeof next === 'number') {
        return 1;
    }
    if (typeof prev === 'string' && typeof next === 'string') {
        return String(prev).toLowerCase().localeCompare(String(next).toLowerCase());
    }
    return prev - next;
}
export function getSortFn(order, orderBy, valueGetter) {
    return order === 'asc'
        ? (a, b) => ascendingSort(a, b, orderBy, valueGetter)
        : (a, b) => -ascendingSort(a, b, orderBy, valueGetter);
}
export function getDateSortFn(order, format = WTS_MOMENT_DATE_MASK, orderBy) {
    return order === 'asc'
        ? (a, b) => ascendingMomentSort(a, b, format, orderBy)
        : (a, b) => -ascendingMomentSort(a, b, format, orderBy);
}
export function ascendingMomentSort(a, b, format, orderBy) {
    const prev = dayjs(orderBy && typeof a === 'object' ? a[orderBy] : a, format).valueOf();
    const next = dayjs(orderBy && typeof b === 'object' ? b[orderBy] : b, format).valueOf();
    return ascSort(prev, next);
}
export function ascendingSort(a, b, orderBy, valueGetter) {
    // @ts-ignore
    const aValue = valueGetter ? valueGetter(a, orderBy) : a[orderBy];
    // @ts-ignore
    const bValue = valueGetter ? valueGetter(b, orderBy) : b[orderBy];
    const prev = Array.isArray(aValue) ? aValue.length : toNumStrOrNull(aValue);
    const next = Array.isArray(bValue) ? bValue.length : toNumStrOrNull(bValue);
    return ascSort(prev, next);
}
export function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
export function defaultTableSorting(list, order, orderBy) {
    return stableSort(list, getSortFn(order, orderBy));
}
export function tableSortingWithValueGetter(list, order, orderBy, valueGetter) {
    return stableSort(list, getSortFn(order, orderBy, valueGetter));
}
